import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
import { Link } from 'react-router-dom';
import { HiEye, HiXCircle } from 'react-icons/hi';
import { Warranty, WarrantyStatusStringEnum } from '../../Models/Warranty';
import { Tooltip } from 'flowbite-react';
import { formatNumbers } from '../../Utils';

export default function WarrantyListTable({
  data,
  deleteWarranty,
}: {
  data: Warranty[];
  deleteWarranty(id: number): void;
}) {
  const columnHelper = createColumnHelper<Warranty>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <Link
            to={`/warranty/claim/${info.getValue()}`}
            className='buttonMain p-2'
          >
            <Tooltip content={`View Warranty`}>
              <HiEye />
            </Tooltip>
          </Link>
          {/* <button
            type='button'
            className='buttonCancel p-2'
            onClick={() => deleteWarranty(info.getValue())}
          >
            <HiXCircle />
          </button> */}
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.statusId, {
      id: 'statusId',
      header: 'Status',
      cell: (info) => <i>{WarrantyStatusStringEnum[info.getValue() ?? 1]}</i>,
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.filledOutByName, {
      id: 'filledOutByName',
      header: 'Name',
      // cell: (info) => <i>{info.getValue()}</i>,
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.model, {
      id: 'model',
      header: 'Model',
      // cell: (info) => <i>{info.getValue()}</i>,
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.serialNumber, {
      id: 'serialNumber',
      header: 'Serial Number',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
